import Vue from 'vue'
import Mutations from '@/store/data/mutations'
export default {
  namespaced: true,
  state: {
    siteId: null,
    projectId: null,
    site: {},
    spoilId: null,
    date: null,
    billingPeriod: null,
    allocations: [],
    commitBatch: false,
    batchLinesByDate: []
  },
  mutations: Mutations,
  actions: {},
  getters: {}
}
